import { Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  content: string | (() => string);
  className?: string;
};
export const MessageTools = ({ className, content }: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  const { t } = useTranslation();

  const onCopy = () => {
    if (typeof content === 'function') {
      content = content();
    }
    navigator.clipboard.writeText(content);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  return (
    <div>
      {isCopied ? (
        <IconCheck size={20} className="text-green-500 dark:text-green-400" />
      ) : (
        <Tooltip label={t('copy')}>
          <span
            className={`cursor-pointer self-start group-hover:visible focus:visible text-gray-600 hover:text-gray-500 dark:text-gray-400 dark:hover:text-gray-300 ${className}`}
            onClick={onCopy}
          >
            <IconCopy size={20} />
          </span>
        </Tooltip>
      )}
    </div>
  );
};
